import { Text, Img, Button } from "../../components";
import React from "react";

export default function EventDetailsSection() {
  return (
    <>
      {/* event details section */}
      <div className="flex flex-col items-center gap-3">
        <div className="flex h-[232px] items-end justify-end self-stretch bg-[url(/public/images/img_group_882.png)] bg-cover bg-no-repeat p-4 md:h-auto">
          <Button className="mt-40 flex h-[40px] w-[42px] items-center justify-center rounded-lg bg-orange-900 p-2.5">
            <Img src="images/img_icon_share_2.svg" />
          </Button>
        </div>
        <div className="container-xs flex flex-col gap-4 self-stretch md:px-5">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-4">
              <div className="flex flex-col items-start gap-[18px]">
                <Text size="text3xl" as="p" className="mt-1.5 text-[18px] font-normal !text-black-900_01">
                  The 3 Most Impactful Food Cost Controls for Independent Restaurants
                </Text>
                <div className="flex flex-col items-start justify-center gap-2.5 self-stretch">
                  <div className="flex flex-col items-start gap-2 self-stretch">
                    <div className="flex gap-2.5 self-stretch">
                      <Img src="images/img_calendar_black_900_01.svg" alt="Calendar" className="h-[18px]" />
                      <Text size="text2xl" as="p" className="text-[16px] font-normal !text-gray-900_01">
                        Mon, Jan 10 · 12:00 pm
                      </Text>
                    </div>
                    <Text as="p" className="!font-inter text-[12px] font-normal !text-gray-900_01">
                      12:00 Pm - 2:00 Pm
                    </Text>
                  </div>
                  <Text as="p" className="text-[12px] font-normal !text-light_blue-a700">
                    Add to calandar
                  </Text>
                </div>
              </div>
              <div className="flex flex-col items-start justify-center gap-2">
                <div className="flex gap-2.5 self-stretch">
                  <Img src="images/img_marker_pin_01.svg" alt="Markerpinone" className="h-[18px]" />
                  <Text size="text2xl" as="p" className="text-[16px] font-normal !text-gray-900_01">
                    Cairo, Egypt
                  </Text>
                </div>
                <Text as="p" className="text-[12px] font-normal !text-gray-900_01">
                  Nazih Khalifa, El-Montaza, Heliopolis, Cairo Governorate
                </Text>
                <Text as="p" className="text-[12px] font-normal !text-light_blue-a700">
                  View on maps
                </Text>
              </div>
            </div>
            <div className="flex flex-col items-start justify-center gap-2">
              <Text size="text2xl" as="p" className="text-[16px] font-normal !text-gray-900_01">
                About
              </Text>
              <Text as="p" className="w-full text-[12px] font-normal leading-[19px] !text-gray-900_01">
                <>
                  It’s been estimated that as much as 10% - 15% of a typical restaurant’s food purchases are lost due to
                  theft, waste or spoilage. Even if it were actually half that amount, the financial effect on any
                  restaurant’s overall profitability would be profound.
                  <br />
                  The reality is, it’s very easy (and common) for restaurants to lose lots of money working with food.
                  Improper...
                </>
              </Text>
              <Text as="p" className="text-[12px] font-normal !text-light_blue-a700">
                Read more..
              </Text>
            </div>
          </div>
          <div className="flex flex-col items-start justify-center gap-[22px]">
            <Text size="text2xl" as="p" className="text-[16px] font-normal !text-gray-900_01">
              About the Presenters:
            </Text>
            <div className="flex items-center gap-1.5 self-stretch">
              <Img
                src="images/img_image_70_44x44.png"
                alt="Imageseventy"
                className="h-[44px] rounded-[12px] object-cover"
              />
              <div className="flex flex-1 flex-col items-start gap-1">
                <Text size="textxl" as="p" className="text-[15px] font-normal !text-gray-900_03">
                  Gohar Said
                </Text>
                <Text as="p" className="text-[12px] font-normal !text-blue_gray-500_01">
                  CEO Suplyd
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
